import axios, { AxiosRequestConfig } from "axios";
import { MarketApiResponse } from "src/model/shop.model";
import { setZaraApiHost } from "src/utils/BasePathTools";

class CatalogApi {
  async getCatalogCountries<T>(): Promise<T | any> {
    const options: AxiosRequestConfig = {
      method: "GET",
    };

    const url = setZaraApiHost(`/itxrest/1/catalog/country`);

    try {
      const response = await axios(url, options);
      return await response.data;
    } catch (error) {
      throw new Error("Failed to fetch countries.");
    }
  }

  async oneTrustIdAndLoadScript<T>(resellStoreId: string): Promise<T | any> {
    const options: AxiosRequestConfig = {
      method: "GET",
    };

    const url = `${setZaraApiHost("/itxrest/1/catalog/store")}/${resellStoreId}`;

    try {
      const response = await axios(url, options);
      return await response.data;
    } catch (error) {
      console.log("Failed to fetch OneTrust ID");
    }
  }
}

export default CatalogApi;
